// Başvuru formu ve başvuru sonrası kart için rol seçenekleri (tek yer). Arka uç karşılığı: kayitIstegiController ROL_LABELS.
export const ROL_GRUPLARI = [
  {
    label: 'İş Güvenliği Profesyoneli (Platform Kullanıcısı)',
    options: [
      { value: 'OSGB_YONETICISI', label: 'OSGB Yöneticisi / Kurucusu' },
      { value: 'OSGB_ISG_UZMANI', label: "OSGB'de Çalışan İş Güvenliği Uzmanı" },
      { value: 'ISLETME_ISG_UZMANI', label: 'İşletme İş Güvenliği Uzmanı (bünyede)' },
      { value: 'BIREYSEL_UZMAN', label: 'Bireysel İş Güvenliği Uzmanı (serbest)' },
      { value: 'ISG_TEKNIKERI', label: 'İş Güvenliği Teknikeri' }
    ]
  }
];

// Arka uç karşılığı: kayitIstegiController ROL_LABELS
export const ROL_ETIKETLERI: Record<string, string> = {
  OSGB_YONETICISI: 'OSGB Yöneticisi / Kurucusu',
  OSGB_ISG_UZMANI: "OSGB'de Çalışan İş Güvenliği Uzmanı",
  ISLETME_ISG_UZMANI: 'İşletme İş Güvenliği Uzmanı',
  ISG_TEKNIKERI: 'İş Güvenliği Teknikeri',
  BIREYSEL_UZMAN: 'Bireysel İş Güvenliği Uzmanı',
  ISYERI_YETKILISI: 'İşyeri / Firma Yetkilisi',
  KARAR_VERICI: 'Kurumsal Karar Verici',
  DANISMAN: 'İSG Danışmanı / Akademisyen',
  DIGER: 'Diğer',
  BELIRTILMEDI: 'Belirtilmedi'
};
